import e from"react";import o from"../../../../assets/images/Icons/Action/perm_identity.svg.js";import t from"../BaseIcon/BaseIcon.js";const s=({viewBox:s="0 0 24 24",...m})=>e.createElement(t,{component:o,viewBox:s,...m});s.displayName="PermIdentity";export{s as default};
//# sourceMappingURL=PermIdentity.js.map
